import { find, map, groupBy, kebabCase } from 'lodash'

export default {
  props: {
    region_id: {
      type: [Number, String]
    }
  },
  data () {
    return {
      region: {}
    }
  },
  mounted () {
    this.findRegion()
  },
  watch: {
    region_id () {
      this.findRegion()
    }
  },
  computed: {
    countries_id() {
      return map(this.region.players, 'country_iso_3')
    },
    allRegions() {
      return this.$store.state.players.regions
    },
    listProviders() {

      let providers =  [] 
      let providersList =  [] 

      map(this.region.players, player => {
        if(player.provider) {
          let pList = player.provider.split(";")
  
          map(pList, p => {
            let new_provider = player
            new_provider.provider_id = kebabCase(p)
            new_provider.url_provider = kebabCase(p)
            providers.push(new_provider)
          })  
  
        }     
      })
      
      
      providersList = map(groupBy(providers, 'provider_id'), (item, provider) => {
        return {
          value: this.translateProvider(provider),
          text: `${this.translateProvider(provider)} (${item.length})`,
          players: item
        }
      })

      providersList.unshift({ value: 'all', text: this.$t('global.all') })

      return providersList
    }
  },
  methods: {
    kebabCase,
    findRegion() {
      let region = find(this.$store.state.players.regions, ['region_id', this.region_id])

      region['meta'] = find(this.$store.state.regions.all, ['region_id', this.region_id])

      this.$set(this, 'region', region)
    }
  }
}
